import {
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  QuestionCircleTwoTone,
  WarningTwoTone,
} from "@ant-design/icons";

type RiskTone = "red" | "yellow" | "green" | "default";

type RiskStatusIconProps = {
  tone: RiskTone;
};

const RISK_STATUS_STYLES = {
  red: {
    icon: WarningTwoTone,
    color: "#DC2626",
  },
  yellow: {
    icon: ExclamationCircleTwoTone,
    color: "#E0B100",
  },
  green: {
    icon: CheckCircleTwoTone,
    color: "#52C41A",
  },
  default: {
    icon: QuestionCircleTwoTone,
    color: "#0C98D0",
  },
} as Record<
  RiskTone,
  { icon: React.ComponentType<{ twoToneColor?: string }>; color: string }
>;

export default function RiskStatusIcon({ tone }: RiskStatusIconProps) {
  const { icon: Icon, color } = RISK_STATUS_STYLES[tone];

  return <Icon twoToneColor={color} />;
}
